import { render, staticRenderFns } from "./DailyRecommend.vue?vue&type=template&id=4a8af15a"
import script from "./DailyRecommend.vue?vue&type=script&lang=js"
export * from "./DailyRecommend.vue?vue&type=script&lang=js"
import style0 from "./DailyRecommend.vue?vue&type=style&index=0&id=4a8af15a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ResearchPaging: require('C:/_Work/Development/source/InfoStock/infostock-front/client/components/Research/ResearchPaging.vue').default})
